import ApiService from "../../services/api.service";

const state = {
    total_installation_partners : 0,
    lowest_installation_price : null
}

const getters = {
    total_installation_partners : state => state.total_installation_partners,
    lowest_installation_price : state => state.lowest_installation_price
}

const mutations = {
    setTotalInstallationPartners(state, value) {
        state.total_installation_partners = value;
    },
    setLowestInstallationPrice(state, payload) {
        state.lowest_installation_price = payload
    }
}

const actions = {
    getTotalInstallationPartners({commit}) {
        return new Promise((resolve, reject) => {
            ApiService.get('/get-total-installation-partners')
                .then(response => {
                    commit('setTotalInstallationPartners', response.data.total_installation_partners);
                    resolve()
                }).catch(() => {
                reject()
            }).finally(() => {

            })
        });
    },
    getLowestInstallationPrice({commit}, payload) {
        return new Promise((resolve, reject) => {
            ApiService.get('/get-lowest-installation-price', { params : {product_id : payload.product_id} })
                .then(response => {
                    commit('setLowestInstallationPrice', response.data.data);
                    resolve()
                }).catch(() => {
                reject()
            }).finally(() => {

            })
        });
    }
}

export default {
    namespaced : true,
    state,
    getters,
    actions,
    mutations
}